"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("../isNotEmpty/index.js"));

var _index2 = _interopRequireDefault(require("../isNotNull/index.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns true if the value is NOT null, undefined, empty.
 *
 * @category Lang
 * @param {*} value - The value to check
 * @returns {boolean}
 * @example
 * isNotNullOrEmpty(null)      // returns false
 * isNotNullOrEmpty(undefined) // returns false
 * isNotNullOrEmpty('')        // returns false
 * isNotNullOrEmpty({})        // returns false
 * isNotNullOrEmpty([])        // returns false
 * isNotNullOrEmpty(' ')       // returns true
 * isNotNullOrEmpty({a: 'b'})  // returns true
 * isNotNullOrEmpty(['a'])     // returns true
 * isNotNullOrEmpty(1)         // returns true
 * isNotNullOrEmpty(true)      // returns true
 * isNotNullOrEmpty(false)     // returns true
 * isNotNullOrEmpty(() => {})  // returns true
 */
var _default = function _default(value) {
  return (0, _index2.default)(value) && (0, _index.default)(value);
};

exports.default = _default;